import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, observable } from 'rxjs';
import { Subject } from 'rxjs';
import { HttpService } from './http/http.service';
import { Batch } from './../interface';

@Injectable({
  providedIn: 'root'
})
export class BatchService {
  constructor(private http: HttpService) { }

  public get(): Promise<Batch[]> {
    return firstValueFrom(this.http.get('/ProductionBatches'));
  }

  public post(data: Batch): Promise<Batch> {
    return firstValueFrom(this.http.post('/ProductionBatches', data));
  }

  public delete(id: number): Promise<void> {
    return firstValueFrom(this.http.delete(`/ProductionBatches/`,id));
  }

}
